import styled from "styled-components";

export const StyledFooter = styled.div`
.footer {
    display: flex;
    justify-content: space-between;
}

.footer-light {
    text-align: center;
    background-color: rgb(248,248,248);
}

.footerSection{
    position: fixed;
    bottom: 0;
    background-color: transparent;
    z-index: 50;
    padding: 0 30px 0 15px;
    height: 30px;
    width: calc(100% - 60px);
    color: #23292f;
    margin-left: 60px !important;
}


.footerSection-lgt {
    position: fixed;
    bottom: -2px;
    background-color: transparent;
    z-index: 50;
    padding: 0 30px 0 15px;
    height: 30px;
    width: calc(100% - 60px);
    color: #23292f;
    margin-left: 60px !important;
}

.footerPolicys{
    display: flex;
}

.footerPolicys-light {
    display: inline-flex;
}

.footerText{
    cursor: pointer;
    margin: 5px;
    font-family: Gelion;
    font-weight: 700;
    font-size: 13px;
}

.footerText:hover{
    text-decoration: none;
}
.copyright{
    margin: 5px 0px;
    font-family: Gelion;
    font-weight: 400;
    font-size: 13px;
}

.footerPolicys div {
    margin: 5px 7px;
}

.footerLink  {
    cursor: pointer;
}
.footerLink a{
    pointer-events: none;
    color: #23292f !important;
}

.leftSection{
    display: flex;
}

.feedback{
    color: #23292f !important;
}

@media screen and (max-width: 1200px){
    .footerText {
        font-size: 11px;
        line-height: 20px;
    }
}
`;


// WEBPACK FOOTER //
// ./src/pages/common/Footer/style.ts